import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { APP_NAME, DEFAULT_LOCALE, SUPPORTED_LOCALES } from '../config.ts';
import fr from './locales/fr.json';

/**
 * i18n con FRANCÉS como único idioma activo.
 *
 * No hay detector de idioma del navegador a propósito: mientras solo exista `fr`,
 * detectar el idioma solo puede llevar a un `fallback` silencioso. Añadir español es
 * añadir el archivo, meterlo en `resources` y sumar 'es' a SUPPORTED_LOCALES; ninguna
 * pantalla cambia porque ninguna tiene texto dentro.
 *
 * `appName` se registra como valor por defecto de interpolación: los textos escriben
 * `{{appName}}` y el nombre sigue estando en un único sitio (app.config.ts).
 */
void i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr } },
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: [...SUPPORTED_LOCALES],
  interpolation: {
    // React ya escapa todo lo que pinta; volver a escapar aquí duplicaría las entidades.
    escapeValue: false,
    defaultVariables: { appName: APP_NAME },
  },
  returnNull: false,
});

export default i18n;
